const GALLERY_SELECTOR = '[data-gallery]';
const PREVIEW_SELECTOR = '[data-gallery-preview]';
const THUMBNAILS_SELECTOR = '[data-gallery-thumbnails]';

class Gallery {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.preview = wrapper.querySelector(PREVIEW_SELECTOR);
    this.thumbnailsList = wrapper.querySelector(THUMBNAILS_SELECTOR);

    // when there is only one image, thumbnail list is not displayed at all
    if (!this.thumbnailsList) {
      return;
    }

    this.thumbnails = this.thumbnailsList.querySelectorAll('a');

    this.bindEvents();
  }

  bindEvents() {
    Array.prototype.forEach.call(this.thumbnails, thumbnail => {
      thumbnail.addEventListener('click', event => {
        event.preventDefault();
        let url = thumbnail.getAttribute('href');
        if (!url) {
          throw new Error('Thumbnail is missing full size url');
        }
        let alt = thumbnail.getAttribute('alt');
        this.updatePreview(url, alt);
      });
    });
  }

  updatePreview(url, alt = '') {
    let oldHeight = this.preview.offsetHeight;
    this.preview.style.minHeight = `${oldHeight}px`;

    let newImage = new Image();
    newImage.onload = () => {
      this.preview.style.minHeight = '0';
    };
    newImage.src = url;

    this.preview.innerHTML = `<img src="${url}" alt="${alt}">`;
  }
}

class Galleries {
  constructor() {
    Array.prototype.forEach.call(
      document.querySelectorAll(GALLERY_SELECTOR),
      wrapper => {
        new Gallery(wrapper);
      }
    );
  }
}

export default Galleries;



// WEBPACK FOOTER //
// ./src/javascripts/DetailView/Galleries.js